function useHiddenProps(_ref) {
  var _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? true : _ref$visible;
  // element props
  return {
    hidden: !visible,
    'aria-hidden': !visible
  };
}

export default useHiddenProps;
//# sourceMappingURL=useHiddenProps.js.map
